skrilla.controller('reassignCsgoMatchModalCtrl', function ($scope, cacheService, modalService, dateService, searchService, queryService) {

    $scope.getDate = dateService.getLocal;
    $scope.beforeDate = new Date();
    $scope.beforeDate.setHours(0, 0, 0, 0);
    $scope.afterDate = new Date($scope.beforeDate);
    $scope.afterDate.setHours($scope.beforeDate.getHours() + 24);

    $scope.seasons = cacheService.getObjectOrElse("csgoSeasons", []);


    $scope.search = function() {
        searchService.get("csgo/matches" + queryService.getQueryString({beforeDate: $scope.beforeDate, afterDate: $scope.afterDate})).then(function (response) {
            $scope.seasons = response.data;
            cacheService.registerObject("csgoSeasons", $scope.seasons);
        });
    }


    $scope.select = function(season, newMatch){
        console.log(newMatch);
        var currentMatch = cacheService.getObject("csgoMatchDetails");
        modalService.confirm("Are you sure you'd like to update this match id?", function(){
            searchService.put("csgo/matches/reassign", {currentMatchId: currentMatch.id, newMatchId: newMatch.id}, "Id successfully updated!").then(function(response){
                currentMatch.sourceId = newMatch.sourceId;
                modalService.dismissAll();
            })
        });
    }

});